import { render, staticRenderFns } from "./chooseTask.vue?vue&type=template&id=4f7b7e8a&"
import script from "./chooseTask.vue?vue&type=script&lang=js&"
export * from "./chooseTask.vue?vue&type=script&lang=js&"
import style0 from "./chooseTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports